/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 13H5v-2h14v2z"/>'
  }
})
